module.exports = __webpack_public_path__ + "img/CATEGORY ICON-09.9d1a428a.png";